import "../phaser.min.js";
import Common from "../Includes/Common.js";
class Deer extends Phaser.Scene {
    constructor() {
        super('Deer');
        this.common = new Common();
    }

    init(data) {
        this.scrollSpeed = data.scrollSpeed;
        this.readyToCreateAnimals = true;
        this.baseSpeed = data.baseSpeed
        this.y = data.y
    }

    preload() {
        // this.load.atlas('level1', this.common.assetsPath + 'sprites/default-scene.png', this.common.assetsPath + 'sprites/default-scene_atlas.json');
    }

    create() {
        this.deerGroup = this.add.group();

        this.addDeer();
        this.readyToCreateAnimals = true;
        this.addDeer(100);
        this.readyToCreateAnimals = true;
        this.addDeer(220);

        const quiz = this.scene.get('Quiz');
        quiz.events.on('scroll-speed-changed', (data) => {
            this.scrollSpeed = data.scrollSpeed;
        }, this)
        quiz.events.on('resetQuestion', () => {
            this.readyToCreateAnimals = true;
        }, this)

        // this.events.once('shutdown', () => {
        //     quiz.events.off('scroll-speed-changed', null, this);
        //     quiz.events.off('resetQuestion', null, this);
        // });


        // On Background Fade Out
        const backgroundManager = this.scene.get('BackgroundManager');
        backgroundManager.events.on('ReflectionBackground-fade-out', () => {
            this.add.tween({
                targets: this.deerGroup.getChildren(),
                alpha: 0,
                duration: 2000,
                ease: 'Linear',
                yoyo: false,
                repeat: 0,
            })
        }, this)
    }

    addDeer(offset = 0) {
        if(this.readyToCreateAnimals) {
            const min = this.y;
            const max = this.y + 30;
            const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
            this.readyToCreateAnimals = false;
            this.newDeer = this.deerGroup.create(this.scale.width * 0.9 + offset, this.y + 50, 'level', 'deer').setScale(this.common.gameScale)
            this.tweens.chain({
                targets: this.newDeer,
                tweens: this.common.popUpTweenChain(randomNumber)})
        }
    }

    removeDeer() {
        if(this.deerGroup.getChildren().length > 0) {
            this.deerGroup.clear(true, true);
        }
    }

    update(time, delta) {
        if(this.deerGroup) {
            let deltaSeconds = delta / 1000;
            let children = this.deerGroup.getChildren();
            for(let child of children) {
                child.x -= this.scrollSpeed * this.baseSpeed * this.common.gameScale * deltaSeconds;
                if (child.x < -100 * this.common.gameScale) {
                    child.x = this.scale.width * 1.25;
                }
            }
        }
    }
}

export default Deer;